import { Controller } from "@hotwired/stimulus"
import { Modal } from 'bootstrap'

export default class extends Controller {
  connect() {
    const modal = new Modal(this.element)
    modal.show()

    this.element.addEventListener('hidden.bs.modal', () => {
      this.element.remove()
    }, { once: true })
  }
}

